import { Icon } from '../atoms/Icon';
import styles from './MarketTileGrid.module.css';

export interface MarketTile {
  key: string;
  title: string;
  /** e.g. the price "6,50 €". */
  subtitle?: string;
  count: number;
  /** e.g. "12 im Bestand"; shown small. */
  hint?: string;
  disabled?: boolean;
}

export interface MarketTileGridProps {
  /** Accessible name of the grid. */
  label: string;
  tiles: MarketTile[];
  onAdd: (key: string) => void;
  onRemove: (key: string) => void;
  /** Accessible labels (no built-in texts, i18n). */
  labels: { add: (title: string) => string; remove: (title: string) => string };
}

/**
 * Large tiles for selling at a market (MKT-001): tapping a tile adds one,
 * the minus button removes one. Built for touch, keyboard works too.
 */
export function MarketTileGrid({ label, tiles, onAdd, onRemove, labels }: MarketTileGridProps) {
  return (
    <ul className={styles.grid} aria-label={label}>
      {tiles.map((t) => (
        <li key={t.key} className={styles.item}>
          <button
            type="button"
            className={styles.tile}
            data-active={t.count > 0 || undefined}
            disabled={t.disabled}
            onClick={() => onAdd(t.key)}
            aria-label={labels.add(t.title)}
          >
            <span className={styles.title}>{t.title}</span>
            {t.subtitle && <span className={styles.subtitle}>{t.subtitle}</span>}
            {t.hint && <span className={styles.hint}>{t.hint}</span>}
            {t.count > 0 && (
              <span className={styles.count} aria-hidden="true">
                {t.count}
              </span>
            )}
          </button>
          {t.count > 0 && (
            <button
              type="button"
              className={styles.minus}
              onClick={() => onRemove(t.key)}
              aria-label={labels.remove(t.title)}
            >
              <Icon name="minus" size="sm" />
            </button>
          )}
        </li>
      ))}
    </ul>
  );
}
